import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

// 在引用vue-router的页面添加一段代码

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 完整路由代码
export default new VueRouter({
    routes: [
        {
            path: '/',
            redirect:"/main/resource-index/resource-content",
        },
        {
            path: '/file-preview',
            name: 'file-preview',
            component: () => import('@/views/preview/FilePreview.vue')
        },
        {
            path: '/app-file-preview',
            name: 'app-file-preview',
            component: () => import('@/views/preview/AppFilePreview.vue')
        },
        {
            path: '/pc-file-preview',
            name: 'pc-file-preview',
            component: () => import('@/views/preview/PcFilePreview.vue')
        },
        {
            path: '/download-page',
            name: 'download-page',
            component: () => import('@/views/user-center/DownloadPage.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue')
        },
        {
            path: '/main',
            name: 'main',
            component: () => import('@/views/Main'),
            children: [
                {
                    path: 'resource-index',
                    name: 'resource-index',
                    component: () => import('@/views/ResourceIndex.vue'),
                    children: [
                        {
                            path: 'history',
                            name: 'history',
                            component: () => import('@/views/history/History.vue')
                        },
                        {
                            path: 'resource-content',
                            name: 'resource-content',
                            component: () => import('@/views/resource-content/ResourceContent.vue')
                        },
                        {
                            path: 'resource-content/:type',
                            name: 'resource-content',
                            component: () => import('@/views/resource-content/ResourceContent.vue')
                        },
                        {
                            path: 'transfer',
                            name: 'transfer',
                            component: () => import('@/views/transfer/Transfer.vue')
                        },
                        {
                            path: 'my-collection',
                            name: 'my-collection',
                            component: () => import('@/views/my-collection/MyCollection.vue')
                        },
                        {
                            path: 'my-share',
                            name: 'my-share',
                            component: () => import('@/views/my-share/MyShare.vue')
                        },
                        {
                            path: 'feedback',
                            name: 'feedback',
                            component: () => import('@/views/feedback/Feedback.vue')
                        },
                        {
                            path: 'recycle',
                            name: 'recycle',
                            component: () => import('@/views/recycle/Recycle.vue')
                        }
                    ]
                }
            ]
        }
    ]
})

